import { render, staticRenderFns } from "./CookieConsentBanner.vue?vue&type=template&id=0054135c&scoped=true&"
import script from "./CookieConsentBanner.vue?vue&type=script&lang=ts&"
export * from "./CookieConsentBanner.vue?vue&type=script&lang=ts&"
import style0 from "./CookieConsentBanner.vue?vue&type=style&index=0&id=0054135c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0054135c",
  null
  
)

export default component.exports